module.exports = __webpack_public_path__ + "img/yellow_unlock.bd3629a2.gif";